<template>
  <basic-dialog :show="show" @close="$emit('close')">
    <template v-slot:title>{{ editorTitle }}</template>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
        <v-row>
          <v-col>
            <v-text-field
              label="Client Type Name"
              v-model="name"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-switch label="Not In Use" v-model="notInUse"></v-switch>
          </v-col>
          <v-col>
            <v-switch label="Is Defaut" v-model="isDefault"></v-switch>
          </v-col>
        </v-row>
    <v-row v-if="debug">
      <v-col cols="12">
        value:
        <code>{{ value }}</code>
      </v-col>
    </v-row>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../shared/BasicDialog";
import Contents from "../shared/contents/Contents";
export default {
  name: "edit-client-type-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => {},
    },
  },

  components: { BasicDialog, Contents },

  data() {
    return {
      debug: false,
      name: this.value ? this.value.name : "",
      notInUse: this.value ? this.value.notInUse : false,
      isDefault: this.value ? this.value.isDefault : false,
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return this.name != "";
    },
    editorTitle() {
      return this.name != "" ? this.name : "Edit Client Type";
    },
  },

  watch: {
    value(newVal) {
      if (newVal) {
        this.name = newVal.name;
        this.notInUse = newVal.notInUse;
        this.isDefault = newVal.isDefault;
      }
    },
  },

  methods: {
    onSave() {
      this.$emit("input", {
        name: this.name,
        id: this.value && this.value.id ? this.value.id : undefined,
        notInUse: this.notInUse == null ? false: this.notInUse,
        isDefault: this.isDefault == null ? false : this.isDefault,
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/clients/EditClientTypeDialog.vue